// Placeholder legal content structure. Replace body content with
// counsel-reviewed text before launch — this establishes the page
// shape and section ordering only.

export type LegalSection = { heading: string; body: string };
export type LegalDoc = { title: string; lastUpdated: string; sections: LegalSection[] };

export const legalDocs: Record<string, LegalDoc> = {
  "privacy-policy": {
    title: "Privacy Policy",
    lastUpdated: "To be confirmed",
    sections: [
      { heading: "Information We Collect", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "How We Use Information", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Data Security", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Your Choices", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Contact", body: "Questions about this policy can be sent to care@theplanetapps.in." },
    ],
  },
  "terms-and-conditions": {
    title: "Terms and Conditions",
    lastUpdated: "To be confirmed",
    sections: [
      { heading: "Acceptance of Terms", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Services", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Accounts and Payment", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Limitation of Liability", body: "Details to be confirmed with counsel and inserted here." },
    ],
  },
  "acceptable-use-policy": {
    title: "Acceptable Use Policy",
    lastUpdated: "To be confirmed",
    sections: [
      { heading: "Purpose", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Prohibited Use", body: "Details to be confirmed with counsel and inserted here." },
      { heading: "Enforcement", body: "Details to be confirmed with counsel and inserted here." },
    ],
  },
  "service-level-agreement": {
    title: "Service Level Agreement",
    lastUpdated: "To be confirmed",
    sections: [
      { heading: "Scope", body: "Details to be confirmed once service commitments are finalised." },
      { heading: "Service Credits", body: "Details to be confirmed once service commitments are finalised." },
    ],
  },
  "refund-policy": {
    title: "Refund Policy",
    lastUpdated: "To be confirmed",
    sections: [
      { heading: "Eligibility", body: "Details to be confirmed with billing/finance and inserted here." },
      { heading: "Process", body: "Details to be confirmed with billing/finance and inserted here." },
    ],
  },
};
